<form nz-form nzLayout="vertical" [formGroup]="validateForm" [nzAutoTips]="autoTips" class="form-container">
    <div nz-row [nzGutter]="48" class="columns-container">
        <div nz-col *ngFor="let panel of formFields; let i = index" [nzSpan]="i === 0 ? 16 : 8" class="column" cdkScrollable (scroll)="onColumnScroll($event)">
            <ng-container *ngFor="let field of panel; let idx = index">
                <nz-form-item *ngIf="field.fieldKey == 'taskName'" (mousedown)="focusedField = field.categoryName || ''">
                    <nz-form-label nzRequired>Task Name</nz-form-label>
                    <nz-form-control>
                        <input nz-input formControlName="taskName" trim="blur" />
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item *ngIf="!editData && field.fieldKey == 'configId'" (mousedown)="focusedField = field.categoryName || ''">
                    <nz-form-label nzRequired> Type</nz-form-label>
                    <nz-form-control>
                        <nz-select nzShowSearch nzAllowClear formControlName="configId" nzPlaceHolder="Select a type"
                            (ngModelChange)="changeTaskType()">
                            <nz-option *ngFor="let option of taskConfigs" [nzValue]="option.id"
                                [nzLabel]="option.configName"></nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item *ngIf="field.fieldKey == 'description'" (mousedown)="focusedField = field.categoryName || ''">
                    <nz-form-label> Description</nz-form-label>
                    <nz-form-control>
                        <app-input-content #descInput formControlName="description" [showAction]="false"
                            [inputWarning]="true" [configId]="validateForm?.value.configId"
                            [editorId]="'add_description'" [members]="projectMembers"></app-input-content>
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item *ngIf="field.fieldKey == 'parentTaskId'" (mousedown)="focusedField = field.categoryName || ''">
                    <nz-form-label> Parent</nz-form-label>
                    <nz-form-control>
                        <nz-select
                                [nzDisabled]="taskId"
                                [nzDropdownRender]="renderTemplate2"
                                nzShowSearch nzAllowClear
                                formControlName="parentTaskId"
                                (nzScrollToBottom)="loadParentTask()"
                                (nzOnSearch)="searchParentTask($event)"
                                [nzLoading]="parentTaskLoading"
                                nzPlaceHolder="Select a linked task">
                            <ng-container *ngFor="let option of parentTaskOptions">
                                <nz-option [nzValue]="option.taskId" [nzLabel]="option.taskName"></nz-option>
                            </ng-container>
                            <nz-option *ngIf="parentTaskLoading && parentTaskOptions.length === 0" nzDisabled nzCustomContent>
                                <i nz-icon nzType="loading" class="loading-icon"></i>
                                Loading Data...
                            </nz-option>
                        </nz-select>
                        <ng-template #renderTemplate2>
                            <nz-spin *ngIf="parentTaskOptions.length > 0 && parentTaskLoading"></nz-spin>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item *ngIf="field.fieldKey == 'linkedTaskIds' && !taskId" (mousedown)="focusedField = field.categoryName || ''">
                    <nz-form-label> Linked Tasks</nz-form-label>
                    <nz-form-control>
                        <nz-select
                                [nzDropdownRender]="renderTemplate"
                                nzShowSearch nzAllowClear nzMode="multiple"
                                formControlName="linkedTaskIds"
                                (nzScrollToBottom)="loadTask()"
                                [nzLoading]="taskLoading"
                                (nzOnSearch)="searchLinkTask($event)"
                                nzPlaceHolder="Select a linked task">
                            <ng-container *ngFor="let option of taskOptions">
                                <nz-option [nzValue]="option.taskId" [nzLabel]="option.taskName"></nz-option>
                            </ng-container>
                            <nz-option *ngIf="taskLoading && taskOptions.length === 0" nzDisabled nzCustomContent>
                                <i nz-icon nzType="loading" class="loading-icon"></i>
                                Loading Data...
                            </nz-option>
                        </nz-select>
                        <ng-template #renderTemplate>
                            <nz-spin *ngIf="taskLoading && taskOptions.length > 0"></nz-spin>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item *ngIf="field.fieldKey == 'swimLaneId'" (mousedown)="focusedField = field.categoryName || ''">
                    <nz-form-label nzRequired>Status</nz-form-label>
                    <nz-form-control>
                        <nz-select nzShowSearch nzAllowClear formControlName="swimLaneId"
                            nzPlaceHolder="Select a status">
                            <nz-option *ngFor="let option of taskSwimLanes" [nzValue]="option.id"
                                [nzLabel]="option.swimLaneName"></nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item *ngIf="field.fieldKey && field.categoryName === 'Date'" (mousedown)="focusedField = field.categoryName || ''">
                    <nz-form-label nzRequired>{{ field.fieldName }}</nz-form-label>
                    <nz-form-control>
                        <nz-date-picker [formControlName]="field.fieldKey"
                            [nzDisabledDate]="disabledDate"></nz-date-picker>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item *ngIf="field.fieldKey == 'priority'" (mousedown)="focusedField = field.categoryName || ''">
                    <nz-form-label> Priority</nz-form-label>
                    <nz-form-control>
                        <nz-select formControlName="priority" [nzAllowClear]="true"
                            [nzCustomTemplate]="priorityTemplate">
                            <ng-template #priorityTemplate let-selected>
                                <!--                                <span nz-icon [nzType]="'svg:'+selected.nzLabel"></span>-->
                                {{ selected.nzLabel }}
                            </ng-template>
                            <nz-option *ngFor="let item of priorityOptions" nzCustomContent [nzLabel]="item.label"
                                [nzValue]="item.value">
                                <!--                                <span nz-icon [nzType]="'svg:'+item.value"></span>-->
                                {{item.label}}
                            </nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item *ngIf="field.fieldKey == 'labels'" (mousedown)="focusedField = field.categoryName || ''">
                    <nz-form-label>Label</nz-form-label>
                    <nz-form-control>
                        <app-label-select formControlName="labels" [showAdd]="true"></app-label-select>
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item *ngIf="field.fieldKey == 'assignees'" (mousedown)="focusedField = field.categoryName || ''">
                    <nz-form-label nzRequired> Assignee</nz-form-label>
                    <nz-form-control>
                        <app-assign-member formControlName="assignees" [projectMembers]="projectMembers"
                            [accountList]="accountList">
                        </app-assign-member>
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item *ngIf="!field.fieldKey" (mousedown)="focusedField = field.categoryName || ''">
                    <nz-form-label [nzRequired]="field.isRequired" *ngIf="!hasTimeCategories.includes(field.categoryName)"> {{
                        field.fieldName }} </nz-form-label>
                    <nz-form-control>
                        <ng-container *ngIf="field" [ngSwitch]="field.categoryName">
                            <input *ngSwitchCase="'Short Text'" nz-input [formControlName]="field.id" />
                            <input *ngSwitchCase="'URL'" nz-input [formControlName]="field.id" />
                            <app-task-resources
                                    *ngSwitchCase="'Resource'"
                                    #resourcesCom
                                    [className]="'form-item'"
                                    [fieldName]="field.fieldName"
                                    [isRequired]="field.isRequired"
                                    [options]="field.options"
                                    [clickToEdit]="false"
                                    [focusedField]="focusedField"
                            ></app-task-resources>
                            <app-task-tester
                                *ngSwitchCase="'Tester'"
                                #testersCom
                                [className]="'form-item'"
                                [fieldName]="field.fieldName"
                                [projectMembers]="projectMembers"
                                [isRequired]="field.isRequired"
                                [accountList]="accountList"
                                [clickToEdit]="false"
                                [focusedField]="focusedField"
                            ></app-task-tester>
                            <app-date-select *ngSwitchCase="'Date'" [formControlName]="field.id" (mousedown)="focusedField = field.categoryName || ''">
                            </app-date-select>

                            <app-date-select *ngSwitchCase="'Timestamp'" [formControlName]="field.id"
                                [nzShowTime]="true" (mousedown)="focusedField = field.categoryName || ''">
                            </app-date-select>
                            <app-input-content *ngSwitchCase="'Paragraph'" [formControlName]="field.id"
                                [editorId]="'add_' + field.id" [showAction]="false"
                                [members]="projectMembers"></app-input-content>
                            <nz-input-number *ngSwitchCase="'Number'" [formControlName]="field.id"
                                [nzMin]="0"></nz-input-number>
                            <app-label-select *ngSwitchCase="'Label'" [showAdd]="true"
                                [formControlName]="field.id"></app-label-select>
                            <nz-select *ngSwitchCase="'DropDown'" nzShowSearch nzAllowClear
                                [nzMode]="field.isRestrained ? 'default' : 'multiple'" [formControlName]="field.id">
                                <nz-option *ngFor="let option of field.options" [nzValue]="option"
                                    [nzLabel]="option"></nz-option>
                            </nz-select>
                            <app-task-checkbox *ngSwitchCase="'Checkbox'" [formControlName]="field.id"
                                [clickToEdit]="false" [options]="field.options"></app-task-checkbox>
                            <!-- <app-file-upload *ngSwitchCase="'Attachment'"
                                [formControlName]="field.id"></app-file-upload> -->
                            <p *ngSwitchCase="'Attachment'" class="attachment-area">Custom Attachment</p>
                            <app-assign-member *ngSwitchCase="'User'" [formControlName]="field.id"
                                [projectMembers]="projectMembers" [accountList]="accountList">
                            </app-assign-member>
                        </ng-container>
                    </nz-form-control>
                </nz-form-item>
            </ng-container>
        </div>
    </div>
</form>
